module.exports = __webpack_public_path__ + "img/banner02.198746ed.png";